"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "Onde fica localizado o estúdio de podcast?",
  answer: "Nosso estúdio premium está estrategicamente localizado em Pinheiros, próximo à Faria Lima, facilitando o acesso para gravações profissionais em São Paulo."
}, {
  question: "Quais serviços vocês oferecem?",
  answer: "Oferecemos produção completa de vídeos corporativos, gravação de podcasts com equipamentos de ponta e gestão de tráfego pago para conversão."
}, {
  question: "Como funciona a gravação de podcast profissional?",
  answer: "Disponibilizamos infraestrutura completa com isolamento acústico, câmeras 4K e edição estratégica para elevar a autoridade da sua marca no digital."
}, {
  question: "Vocês auxiliam na estratégia de distribuição?",
  answer: "Sim, além da produção audiovisual, estruturamos campanhas de tráfego pago para garantir que seu conteúdo alcance o público-alvo ideal em São Paulo."
}];
export default function FaqAccordion() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="243053" id="faqaccordion" className="bg-background py-16 md:py-24 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="container mx-auto px-4 max-w-3xl relative z-10">
        <div ref={ref} className={`transition-all duration-700 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-foreground font-default mb-4">
              Perguntas Frequentes
            </h2>
            <p className="text-muted-foreground text-lg font-default">
              Tudo o que você precisa saber sobre nossas produções e estúdio em Pinheiros.
            </p>
          </div>

          <div className="bg-white border border-border rounded-2xl overflow-hidden shadow-sm">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} data-index={index} className="border-border px-4 md:px-6 transition-colors hover:bg-muted/30">
                  <AccordionTrigger className="text-base md:text-lg font-semibold text-foreground hover:no-underline py-6 [&>svg]:text-primary [&>svg]:size-5 font-default">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground text-base pb-6 leading-relaxed pr-8 font-default">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}